<div class="border-1 surface-border border-round p-4">
  @if (coverageAmountOptions.length) {
    <em-coverage-card i18n-title title="Assurance temporaire">
      <p-dropdown
        [options]="coverageAmountOptions"
        [filter]="true"
        [virtualScroll]="true"
        [virtualScrollItemSize]="30"
        filterBy="value,name"
        filterMatchMode="startsWith"
        [formControl]="form.controls.coverageAmount"
        optionLabel="name"
        optionValue="value"></p-dropdown>
    </em-coverage-card>
  } @else {
    <em-coverage-card i18n-title title="Assurance temporaire">
      <i i18n>Aucune couverture disponible.</i>
    </em-coverage-card>
  }
  @if (form.controls.coverageAmount.value && withProductSelection) {
    <div class="p-5">
      <h3 class="text-primary mb-2" i18n>Choix du produit</h3>
      <p i18n>Sélectionnez une des options suivantes.</p>

      <p-table
        [value]="showAllProducts ? allPossibleProducts : mainProducts"
        [selection]="allPossibleProducts[selectedProductIndex]"
        (onRowSelect)="onSelect($event)"
        [scrollable]="true"
        scrollHeight="500px"
        dataKey="value"
        selectionMode="single">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 3rem"></th>
            <th i18n>Produit</th>
            <th class="text-right" i18n>Prime</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-lifeInsuranceProduct>
          <tr>
            <td>
              <p-tableRadioButton
                [value]="lifeInsuranceProduct"
                [disabled]="lifeInsuranceProduct === allPossibleProducts[selectedProductIndex]">
              </p-tableRadioButton>
            </td>
            <td>{{ lifeInsuranceProduct.name | emTranslate }}</td>
            @if (!isPriceLoading) {
              <td class="text-right"
                >{{ (lifeInsuranceProduct.price | currency: 'CAD' : 'symbol-narrow' : '1.2-2') || '--' }}
              </td>
            }
            @if (isPriceLoading) {
              <td class="text-right">
                <p-progressSpinner
                  strokeWidth="6"
                  [style]="{width: '100%', height: '15px'}"></p-progressSpinner>
              </td>
            }
          </tr>
        </ng-template>
      </p-table>

      <div class="mt-3 flex justify-content-end">
        @if (!showAllProducts) {
          <p-button
            [outlined]="true"
            i18n-label
            label="Voir plus d'options"
            (onClick)="toggleShowAllDurations()"
            icon="pi pi-arrow-down"></p-button>
        }
        @if (showAllProducts) {
          <p-button
            [outlined]="true"
            i18n-label
            label="Voir moins d'options"
            (onClick)="toggleShowAllDurations()"
            icon="pi pi-arrow-up"></p-button>
        }
      </div>

      <div
        (click)="openRenewalPricesDialog()"
        class="flex cursor-pointer justify-content-center text-sm text-color-secondary pt-4">
        <i class="pi pi-eye pr-2"></i>
        <b i18n>Voir prime du renouvellement</b>
      </div>
    </div>
  }
</div>
